import useAiWidgetStore from '../stores/useAiWidgetStore';

/**
 * Open (or focus) an entity-backed Team group thread in CommunicationHub.
 * Idempotent — selecting the same entity again focuses the existing thread.
 */
export function openEntityGroupChat({entityType, entityId, title}) {
    if (!entityType || !entityId) return;
    const store = useAiWidgetStore.getState();
    store.setActiveEntityGroup({
        entityType,
        entityId,
        entityTitle: title || '',
    });
    store.setOpen(true);
    store.setActiveTab('team');
}

export function entityGroupKey({entityType, entityId}) {
    if (!entityType || !entityId) return null;
    return `${entityType}:${entityId}`;
}

export function formatEntityGroupLabel(entityType, displayTitle) {
    const title = displayTitle || 'Untitled';
    if (entityType === 'product') return `Product: ${title}`;
    return `Chart: ${title}`;
}
